import Icon from './icon'
export default Icon




// WEBPACK FOOTER //
// ./components/icon/index.js